export default __webpack_public_path__ + "static/media/washingMashinOrange.84dacb66.svg";